import React from 'react';
import ResultsCardContainer from '../containers/ResultsCardContainer';

class WhatIfResultsListPres extends React.Component {
  render() {
    const { results, onCompare, onDelete, onViewExcel } = this.props;
    const selectedResults = results.filter(item => {
      return item.selected;
    });
    return (
      <div className="whatif-results">
        <div className="whatif-results-header">
          <button class={'header-button ' + (selectedResults.length > 1 ? '' : 'header-button-disabled')} onClick={onCompare}>
            Compare
          </button>
          <button class={'header-button ' + (selectedResults.length > 0 ? '' : 'header-button-disabled')} onClick={onDelete}>
            Delete
          </button>
          <button class={'header-button'} onClick={onViewExcel}>
            View Excel
          </button>

          {/*<div className="whatif-results-threedotmenu">
                  <ThreeDotMenu options={menuOptions} handleMenuSelect={handleMenuSelect} />
          </div>*/}
        </div>
        <div className="whatif-results-body">
          <div className="whatif-results-list-grid">
            {results.map((result, index) => {
              return (
                <div className="whatif-results-list-griditem">
                  <ResultsCardContainer
                    key={result.key + index}
                    index={index}
                    result={result}
                    maxCompensation={this.props.maxCompensation}
                    handleResultCancel={this.props.handleResultCancel.bind(this)}
                    handleResultSelect={this.props.handleResultSelect.bind(this)}
                    handleResultClick={this.props.onDetail.bind(this)}
                  />
                </div>
              );
            })}
          </div>
        </div>
        {/* <div className="whatif-results-footer">
          <div className="button-wrapper">
            <Button styleType="secondary" className="action-button" onClick={this.props.onCompare} disabled={selectedResults.length <= 1}>
              Compare
            </Button>
            <Button styleType="secondary" className="action-button" onClick={this.props.onViewExcel}>
              View Excel
            </Button>
            <Button className="action-button submit-button">Initiate Case</Button>
            <Button styleType="secondary" className="icon-button action-button" onClick={this.props.handleEdit}>
              <Edit /> Edit
            </Button>
          </div>
        </div> */}
      </div>
    );
  }
}

export default WhatIfResultsListPres;
